export enum RowOrigin {
    IMPORT = "IMPORT",
    MANUAL = "MANUAL",
    SYNTHESIS = "SYNTHESIS",
    PLAYGROUND = "PLAYGROUND",
    COPY = "COPY",
}

export function resolveRowOriginName(origin: RowOrigin): string {
    switch (origin) {
        case RowOrigin.IMPORT: return "Imported"
        case RowOrigin.MANUAL: return "Created manually"
        case RowOrigin.SYNTHESIS: return "Synthesized"
        case RowOrigin.PLAYGROUND: return "From playground"
        case RowOrigin.COPY: return "Copied"
    }
}
